// extracted by css-extract-rspack-plugin
export default {"container":"container-Khz1GU","borderForPatients":"borderForPatients-fIxTAr"};